import { useState, useRef, useEffect } from 'react';
import { Button, TextField, Typography } from '@hid-galaxy-ui/galaxy-react';
import { Field, Form, Formik } from 'formik';
import { NotificationError, NotificationSuccess } from '../../../../utils/notification';
import {
  ResendOtp,
  updatePassword,
  validateEmailOtp,
} from '../../../../services/app-user/app-user';
import { useHistory } from 'react-router-dom';
import buildPATHS from '../../../../utils/paths';
import styles from './OtpValidationForm.module.scss';
import { TypographyVariantEnum } from '@hid-galaxy-ui/galaxy-react/components/Typography/typographyEnum';
import cx from 'classnames';
import { APP_TYPE, RESEND_OTP_TIME } from '../../constant';
import { getTranslation } from '../../../../utils/functions';
import LodashUtils from '../../../../utils/lodashUtils';
import useTimer from '../../../../hooks/useTimer';
import { ONLY_NUMBER_REGEX } from '../../../../constants/regex';
import { IAppProps } from '../../../../App';
import BoxLogo from '../../../../components/BoxLogo/BoxLogo';
import {
  IResendOtpParams,
  IUpdatePasswordParams,
  IValidateEmailOtpParams,
} from '../../../../services/app-user/IAppUser';
import InputPassword from '../../../../components/Inputs/InputPassword/InputPassword';
import { useSelector } from 'react-redux';
import { RootStore } from '../../../../store/reducers';
import { userStateSelector } from '../../../../store/selectors/userSelectors';
import { InputsSchema } from '../../../../hooks/buildRegisterForm/validationSchema';
import * as Yup from 'yup';
import PasswordGuideline from '../../../../components/PasswordGuideline/PasswordGuideline';

const ChangePassword = (props: IAppProps) => {
  const { setToasts, toasts } = props;

  const history = useHistory();
  const PATHS = buildPATHS();
  const { accountData } = useSelector((state: RootStore) => ({
    accountData: userStateSelector(state),
  }));

  const [validated, setValidated] = useState(false);

  const validatedValue = (val) => {
    setValidated(val);
  };

  const handleSubmit = async (values: Partial<IUpdatePasswordParams>, { setFieldError }) => {
    if (!validated) {
      setFieldError('newPassword', getTranslation('PASSWORD_GUIDLINES_NOT_MATCHED'));
      return;
    }

    try {
      const payload: IUpdatePasswordParams = {
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
        email: accountData?.email,
      };
      const response = await updatePassword(payload);

      setToasts([...toasts, ...NotificationSuccess('PASSWORD_UPDATED_SUCCESS')]);
      history.push(PATHS.login);
    } catch (error) {
      setToasts([...toasts, ...NotificationError('ENTER_CORRECT_PASSWORD')]);
    }
  };

  const buildFormValidation = () => {
    return Yup.object().shape({
      currentPassword: InputsSchema.TEXTFIELD({
        required: true,
        properties: {
          errorMessageRequired: 'CURRENT_PASSWORD_REQUIRED',
        },
      }),

      newPassword: InputsSchema.TEXTFIELD({
        required: true,
        properties: {
          errorMessageRequired: 'NEW_PASSWORD_REQUIRED',
        },
      }),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], getTranslation('PASSWORDS_MUST_MATCH'))
        .required(getTranslation('CONFIRM_PASSWORD_MSG')),
    });
  };
  return (
    <>
      <Formik
        initialValues={{
          currentPassword: '',
          newPassword: '',
        }}
        onSubmit={handleSubmit}
        validationSchema={buildFormValidation()}
      >
        {({ submitForm, errors, values, isValid }) => (
          <div className="hid-grid">
            <Form
              className={cx(
                'hid-spacing__px-03',
                'hid-grid__column hid-grid__column--12-xs hid-grid__column--4-sm',
              )}
            >
              <Field
                key="currentPassword"
                component={InputPassword}
                label={getTranslation('CURRENT_PASSWORD')}
                name="currentPassword"
                id="currentPassword"
                required={true}
              />
              <Field
                key="newPassword"
                component={InputPassword}
                label={getTranslation('NEW_PASSWORD')}
                name="newPassword"
                id="newPassword"
                required={true}
              />
              <Field
                key="confirmPassword"
                component={InputPassword}
                label={getTranslation('CONFIRM_NEW_PASSWORD')}
                name="confirmPassword"
                id="confirmPassword"
                required={true}
              />

              <div className="hid-flex hid-flex-row hid-flex-jc-end hid-text-center hid-spacing__mt-07">
                <Button
                  // disabled={!validated || !isValid}
                  type="submit"
                  label={getTranslation('CHANGE_PASSWORD')}
                />
              </div>
            </Form>
            <div
              className={cx(
                'hid-spacing__px-07',
                'hid-grid__column hid-grid__column--12-xs hid-grid__column--4-sm',
                'hid-spacing__mt-07',
              )}
            >
              <PasswordGuideline
                setValidated={(isValidated) => validatedValue(isValidated)}
                password={values.newPassword}
              />
            </div>
          </div>
        )}
      </Formik>
    </>
  );
};

export default ChangePassword;
